/** Hosted pay page (pay.aistylemedia.com) and its card option. */
export default {
  amountToPay: "Amount to pay: <amount>{{amount}}</amount>",
  redirecting: "Redirecting…",
  unavailableTitle: "Checkout unavailable",
  linkUnavailable: "This payment link is no longer available.",
  alreadyStarted: "This payment was already started.",
  secureNote: "Payments are encrypted and protected by 3-D Secure",
  errors: {
    missingId: "Missing payment id.",
    loadFailed: "Could not load this payment.",
    startFailed: "Could not start the payment.",
  },
  card: {
    name: "Card payment",
    description: "Pay securely by card. Protected by 3-D Secure.",
    unavailable: "Temporarily unavailable.",
    proceed: "Proceed with Credit Card",
  },
};
